module.exports = __webpack_public_path__ + "media/images/products/label-experienceBetter-40c6d75fb6bb28c3307182a34f43d06a.png";